import {
  SocketAsFetch as LeagueSocketAsFetch,
  type WebsocketMessage,
  type FetchOptions,
} from '@leagueplatform/socket-as-fetch';
import { combineErrorContexts } from '@leagueplatform/observability';

export const socketAsFetch = (
  message: WebsocketMessage,
  options?: FetchOptions,
) =>
  LeagueSocketAsFetch.fetch(message, {
    // Spread first so every FetchOptions member (e.g. onInternalError)
    // passes through; the merged errorContext deliberately wins.
    ...options,
    errorContext: combineErrorContexts([
      {
        errorName: `Geisinger Socket Fetch Response Error - ${message.message_type}`,
      },
      options?.errorContext || {},
    ]),
  });
